import React from "react";
import "./Countingsection.css";
import growthImg from '../Images/taxfilings.webp';
import successImg from '../Images/globalclients.webp';

import hoursImg from '../Images/hours.webp';
import professionalImg from '../Images/professional.webp';

import { 
  FaFileAlt, FaUniversity, FaBalanceScale, FaIdCard, 
  FaChartLine, FaGlobe, FaBook, FaUsersCog 
} from 'react-icons/fa';

const Countingsection = () => {
  const services = [
    { name: "Amendment Filing", icon: <FaFileAlt />, description: "Correct errors or update your previous tax returns with accurate amendment filing." },
    { name: "Federal & State Filing", icon: <FaUniversity />, description: "Ensure accurate and timely filing for both federal and state tax returns." },
    { name: "Tax Representation", icon: <FaBalanceScale />, description: "Professional representation and support in dealing with IRS and state authorities." },
    { name: "ITIN Preparation", icon: <FaIdCard />, description: "Assistance with obtaining or renewing your Individual Taxpayer Identification Number (ITIN)." },
    { name: "Advance Tax Planning", icon: <FaChartLine />, description: "Proactive strategies to minimize liabilities and maximize savings for the future." },
    { name: "FBAR & FATCA Compliance", icon: <FaGlobe />, description: "Stay compliant with foreign account reporting and FATCA requirements." },
    { name: "Bookkeeping Services", icon: <FaBook />, description: "Accurate record-keeping to keep your finances organized and audit-ready." },
    { name: "Payroll Management", icon: <FaUsersCog />, description: "End-to-end payroll services ensuring timely and accurate employee compensation." }
  ];

  return (
    <section className="countingsection-wrapper">
      {/* Left Side - Intro + Stats */}
      <div className="countingsection-left">
        <h2 className="countingsection-heading">
          Driving Growth with <span className="highlight">Expert Tax & Business Solutions</span>
        </h2>
        <p className="countingsection-subtext">
          From saving countless hours to building financial security, we empower individuals
          and businesses to achieve their goals with confidence.
        </p>

        {/* Stats Section */}
        <div className="countingsection-right">
          <div className="count-card">
            <img src={growthImg} alt="Financial Growth" className="count-img" />
            <h3><span className="count-strong">850+</span> Successful Tax Filings Every Year</h3>
          </div>

          <div className="count-card">
            <img src={successImg} alt="Client Success" className="count-img" />
            <h3><span className="count-strong">1900+</span> Trusted Clients Across the Globe</h3>
          </div>

          <div className="count-card">
            <img src={hoursImg} alt="Expert Support" className="count-img" />
            <h3><span className="count-strong">10,000+</span> Hours Saved with Our Expert Support</h3>
          </div>

 <div className="count-card">
    <img src={professionalImg} alt="Experience" className="count-img" />
    <h3><span className="count-strong">8+</span> Years of Professional Experience</h3>
  </div>

        </div>
      </div>

      {/* Right Side - Services */}
      <div className="services-section">
        <h1 className="services-title">Our Core Services</h1>
        <p className="services-subtitle">
          Expert tax, compliance, and business solutions tailored to your needs.
        </p>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.name}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Countingsection;
